import { FlexBox } from "@brg/ui";
import { LayoutConst } from "core";
import { CheckBoxWrapper } from "shared/components/Radio/styles";
import styled, { css } from "styled-components";

export const Wrapper = styled(FlexBox)`
    flex-flow: column;
    width: 100%;
    justify-content: center;
    place-items: center;

    [data-education="true"] {
        svg path[fill="#151514"] {
            fill: #fff !important;
        }
    }
`;

export const Title = styled.div`
    font-weight: 600;
    font-size: 43px;
    line0-height: 51px;
    margin-bottom: 56px;

    @media(max-width: ${LayoutConst.screen.md}px) {
       font-size: 34px;
       line-height: 41px; 
    }
`;

export const Container = styled(FlexBox)`
    flex-flow:column;

    .left-side {
        // width: ${LayoutConst.projectCover.l.w}px;
        width: 420px;
    }

    .right-side {
        width: 676px;
    }

    @media(max-width: ${LayoutConst.screen.mac13}px) {
        .side {
            width: ${LayoutConst.projectCover.m.w}px;
        }
    }

    @media(max-width: ${LayoutConst.screen.md}px) {
        .side {
            width: ${LayoutConst.projectCover.s.w}px;
        }
    }
`;

export const AddButton = styled(FlexBox)<{ disable?: boolean, filled?: boolean }>`
    width: 176px;
    min-width: 176px;
    place-items: center;
    justify-content: center;
    font-size: 17px;
    line-height: 22px;
    font-weight: 600;
    height: 46px;
    color: #151514;
    border-radius: 3px;
    border: 1px solid rgba(182, 182, 181, 1);
    cursor: pointer;
    margin-left: 12px;
    user-select: none;

    ${({ filled }) => filled && css`
        background-color: rgba(21, 21, 20, 1);
        color: #fff;
    `};

    ${({ disable }) => disable && css`
        pointer-events: none;
        color: #b6b6b5;
        border: 1px solid #f2f2f2;
        background-color: transparent;
    `};

    @media(max-width: ${LayoutConst.screen.md}px) {
        font-size: 15px;
        line-height: 20px;
    }
`;

export const ColumnContainer = styled(FlexBox)`
    flex-flow: column;

    .lang-container {
        margin-right: 0;
    }

    .add-button {
        height: 46px;
        max-height: 46px;
        max-width: 274px;
        min-width: auto;

        span {
            font-weight: 600;
            font-size: 17px;
            line-height: 22px;

            @media(max-width: ${LayoutConst.screen.md}px) {
                font-size: 15px;
                line-height: 20px;
            }
        }
    }

    input {
        max-width: 676px;
        background-color: rgba(242, 242, 242, 1);
        border: none !important;
        color: rgba(21, 21, 20, 1);
        outline: none !important;
        max-height: 46px;
    }

    .label {
        font-size: 30px;
        line-height: 33px;
        font-weight: 600;
        color: #151514;
        font-family: 'Inter';

        @media(max-width: ${LayoutConst.screen.md}px) {
            font-size: 23px;
            line-height: 27px
        }

        @media(max-width: ${LayoutConst.screen.s - 1}px) {
            font-size: 20px;
            line-height: 25px
        }
    }

    .description {
        font-size: 17px;
        line-height: 22px;
        font-weight: 400;
        color: #151514;
        margin-top: 8px;
    }

`;

export const RowContainer = styled(FlexBox)`
    flex-flow: column;

    .brg-input__menu {
        .brg-input__option {
            cursor: pointer;
        }
        .brg-input__option--is-focused {
          background-color: #e7e7e7 !important;
        }
        .brg-input__option--is-focused:hover {
          background-color: #e7e7e7 !important;
        }
    }

    .lang-container {
        margin-right: 0;
    }


    input {
        max-width: 564px;
        background-color: rgba(242, 242, 242, 1);
        border: none !important;
        color: rgba(21, 21, 20, 1);
        outline: none !important;
        max-height: 46px;
    }

    .description {
        font-size: 17px;
        line-height: 22px;
        font-weight: 400;
        color: #151514;
        margin-top: 8px;
    }

    .label {
        font-size: 26px;
        line-height: 32px;
        font-weight: 600;
        color: #151514;
        font-family: 'Inter';

        @media(max-width: ${LayoutConst.screen.md}px) {
            font-size: 23px;
            line-height: 27px
        }

        @media(max-width: ${LayoutConst.screen.s - 1}px) {
            font-size: 20px;
            line-height: 25px
        }
    }

    .dropdown-button {
        height: 46px;
        background-color: rgba(242, 242, 242, 1);
        padding: 12px 16px;
    }

    .dropdown-element-popup {
        width: 100%;
        max-width: 100%;
    }

    .brg-input__control {
        max-height: 46px;
    }

    .brg-input__control, .brg-input__menu {
        background-color: #f2f2f2 !important;
        color: rgba(112, 112, 111, 1) !important;
        border: none;
        margin-top: 0;
    }

    .brg-input__menu-list {
        color: rgba(112, 112, 111, 1) !important;
        ::-webkit-scrollbar {
            height: 2px;
            width: 1px;
        }
        ::-webkit-scrollbar-thumb {
            background: #151514;
        }
        ::-webkit-scrollbar-track {
            background: transparent;
        }
    }

    .brg-input__indicator {
        opacity: 1;
        svg path {
            fill: #b6b6b5;
        }
    }

    .brg-input__menu {
        * {
            color: rgba(112, 112, 111, 1) !important;
            font-weight: 400;
            font-size: 17px;
            line-height: 22px;
        }

        svg path {
            fill: #151514;
        }
    }

    .brg-input__single-value {
        color: #151514 !important;
        font-weight: 400;
        font-size: 17px;
        line-height: 22px;
    }

    .add-button {
        height: 46px;
        max-height: 46px;

        span {
            font-weight: 600;
            font-size: 17px;
            line-height: 22px;

            @media(max-width: ${LayoutConst.screen.md}px) {
                font-size: 15px;
                line-height: 20px;
            }
        }
    }

`;

export const TargetWrapper = styled(FlexBox)`
    .text {
        font-size: 17px;
        line-height: 22px;
        font-weight: 400;   
    }
    
    svg {
        margin-top: 2px;
    }
`;

export const EditTitleContainer = styled(FlexBox)`
    svg {
        cursor: pointer;
        path {
            transition: fill 0.2s;
        }
        &:hover {
            path {
                fill: #151514;
                transition: fill 0.2s;
            }
        }
    }
`;

export const EditTextarea = styled.textarea<{ isEdit?: boolean }>`
    font-size: 30px;
    line-height: 33px;
    font-weight: 600;
    color: #151514;
    font-family: 'Inter';
    outline: none;
    border-color: ${({ isEdit }) => !isEdit ? 'transparent' : '1px solid rgba(144, 144, 144, 1)'};
    padding-bottom: ${({ isEdit }) => !isEdit ? '0' : '4px'};
    border-top: 0;
    border-left: 0;
    border-right: 0;
    border-bottom: ${({ isEdit }) => !isEdit ? 'none' : '0 0 1px 0 solid rgba(144, 144, 144, 1)'};
    overflow-y: hidden;
    resize: none;
    background-color: transparent;
    width: 90%;

    @media(max-width: ${LayoutConst.screen.md}px) {
        font-size: 23px;
        line-height: 27px;
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
        font-size: 20px;
        line-height: 25px;
    }
`;

export const EditTitle = styled.div<{ isEdit?: boolean }>`
    font-size: 30px;
    line-height: 33px;
    font-weight: 600;
    color: #151514;
    font-family: 'Inter';
    padding-bottom: ${({ isEdit }) => !isEdit ? '0' : '4px'};
    border-bottom: ${({ isEdit }) => !isEdit ? 'none' : '1px solid rgba(144, 144, 144, 1)'};
`;

export const SmallLabel = styled.span`
    color: rgba(144, 144, 144, 1);
    font-size: 13px;
    line-height: 16px;
    white-space: nowrap;
    font-weight: 400;
    margin-bottom: 12px;
`;

export const DropdownWrapper = styled.div`
    width: 100%;
    > div {
        width: 100%; 
    }
`;

export const EditButtonsWrapper = styled(FlexBox)`
    .add-button {
        height: 46px;
        max-height: 46px;
        text-align: center;
    }
`;

export const NewCategoryInputsContainer = styled(FlexBox)`
    padding: 24px 0 24px 0;
    border-top: 1px solid rgba(205, 205, 205, 1);
    border-bottom: 1px solid rgba(205, 205, 205, 1);
`;

export const NewCategoryButtonsContainer = styled(FlexBox)`
    ${AddButton} {
        width: calc(50% - 12px);
    }
`;

export const CreateNewCatalogContainer = styled(FlexBox)`
    border-top: 1px solid rgba(205, 205, 205, 1);
    padding-top: 24px;
`;

export const TagsTypeLabel = styled.div`
    font-size: 15px;
    line-height: 16px;
    font-family: 'Inter';
    color: #909090;
    white-space: nowrap;

`;

export const RadioContainer = styled(FlexBox)`
    ${CheckBoxWrapper} {
        width: auto;
    }
`;
import { FlexBox } from "@brg/ui";
import { LayoutConst } from "core";
import { CheckBoxWrapper } from "shared/components/Radio/styles";
import styled, { css } from "styled-components";

export const Wrapper = styled(FlexBox)`
    flex-flow: column;
    width: 100%;
    justify-content: center;
    place-items: center;

    [data-education="true"] {
        svg path[fill="#151514"] {
            fill: #fff !important;
        }
    }
`;

export const Title = styled.div`
    font-weight: 600;
    font-size: 43px;
    line0-height: 51px;
    margin-bottom: 56px;

    @media(max-width: ${LayoutConst.screen.md}px) {
       font-size: 34px;
       line-height: 41px; 
    }
`;

export const Container = styled(FlexBox)`
    flex-flow:column;

    .left-side {
        // width: ${LayoutConst.projectCover.l.w}px;
        width: 420px;
    }

    .right-side {
        width: 676px;
    }

    @media(max-width: ${LayoutConst.screen.mac13}px) {
        .side {
            width: ${LayoutConst.projectCover.m.w}px;
        }
    }

    @media(max-width: ${LayoutConst.screen.md}px) {
        .side {
            width: ${LayoutConst.projectCover.s.w}px;
        }
    }
`;

export const AddButton = styled(FlexBox)<{ disable?: boolean, filled?: boolean }>`
    width: 176px;
    min-width: 176px;
    place-items: center;
    justify-content: center;
    font-size: 17px;
    line-height: 22px;
    font-weight: 600;
    height: 46px;
    color: #151514;
    border-radius: 3px;
    border: 1px solid rgba(182, 182, 181, 1);
    cursor: pointer;
    margin-left: 12px;
    user-select: none;

    ${({ filled }) => filled && css`
        background-color: rgba(21, 21, 20, 1);
        color: #fff;
    `};

    ${({ disable }) => disable && css`
        pointer-events: none;
        color: #b6b6b5;
        border: 1px solid #f2f2f2;
        background-color: transparent;
    `};

    @media(max-width: ${LayoutConst.screen.md}px) {
        font-size: 15px;
        line-height: 20px;
    }
`;

export const ColumnContainer = styled(FlexBox)`
    flex-flow: column;

    .lang-container {
        margin-right: 0;
    }

    .add-button {
        height: 46px;
        max-height: 46px;
        max-width: 274px;
        min-width: auto;

        span {
            font-weight: 600;
            font-size: 17px;
            line-height: 22px;

            @media(max-width: ${LayoutConst.screen.md}px) {
                font-size: 15px;
                line-height: 20px;
            }
        }
    }

    input {
        max-width: 676px;
        background-color: rgba(242, 242, 242, 1);
        border: none !important;
        color: rgba(21, 21, 20, 1);
        outline: none !important;
        max-height: 46px;
    }

    .label {
        font-size: 30px;
        line-height: 33px;
        font-weight: 600;
        color: #151514;
        font-family: 'Inter';

        @media(max-width: ${LayoutConst.screen.md}px) {
            font-size: 23px;
            line-height: 27px
        }

        @media(max-width: ${LayoutConst.screen.s - 1}px) {
            font-size: 20px;
            line-height: 25px
        }
    }

    .description {
        font-size: 17px;
        line-height: 22px;
        font-weight: 400;
        color: #151514;
        margin-top: 8px;
    }

`;

export const RowContainer = styled(FlexBox)`
    flex-flow: column;

    .brg-input__menu {
        .brg-input__option {
            cursor: pointer;
        }
        .brg-input__option--is-focused {
          background-color: #e7e7e7 !important;
        }
        .brg-input__option--is-focused:hover {
          background-color: #e7e7e7 !important;
        }
    }

    .lang-container {
        margin-right: 0;
    }


    input {
        max-width: 564px;
        background-color: rgba(242, 242, 242, 1);
        border: none !important;
        color: rgba(21, 21, 20, 1);
        outline: none !important;
        max-height: 46px;
    }

    .description {
        font-size: 17px;
        line-height: 22px;
        font-weight: 400;
        color: #151514;
        margin-top: 8px;
    }

    .label {
        font-size: 26px;
        line-height: 32px;
        font-weight: 600;
        color: #151514;
        font-family: 'Inter';

        @media(max-width: ${LayoutConst.screen.md}px) {
            font-size: 23px;
            line-height: 27px
        }

        @media(max-width: ${LayoutConst.screen.s - 1}px) {
            font-size: 20px;
            line-height: 25px
        }
    }

    .dropdown-button {
        height: 46px;
        background-color: rgba(242, 242, 242, 1);
        padding: 12px 16px;
    }

    .dropdown-element-popup {
        width: 100%;
        max-width: 100%;
    }

    .brg-input__control {
        max-height: 46px;
    }

    .brg-input__control, .brg-input__menu {
        background-color: #f2f2f2 !important;
        color: rgba(112, 112, 111, 1) !important;
        border: none;
        margin-top: 0;
    }

    .brg-input__menu-list {
        color: rgba(112, 112, 111, 1) !important;
        ::-webkit-scrollbar {
            height: 2px;
            width: 1px;
        }
        ::-webkit-scrollbar-thumb {
            background: #151514;
        }
        ::-webkit-scrollbar-track {
            background: transparent;
        }
    }

    .brg-input__indicator {
        opacity: 1;
        svg path {
            fill: #b6b6b5;
        }
    }

    .brg-input__menu {
        * {
            color: rgba(112, 112, 111, 1) !important;
            font-weight: 400;
            font-size: 17px;
            line-height: 22px;
        }

        svg path {
            fill: #151514;
        }
    }

    .brg-input__single-value {
        color: #151514 !important;
        font-weight: 400;
        font-size: 17px;
        line-height: 22px;
    }

    .add-button {
        height: 46px;
        max-height: 46px;

        span {
            font-weight: 600;
            font-size: 17px;
            line-height: 22px;

            @media(max-width: ${LayoutConst.screen.md}px) {
                font-size: 15px;
                line-height: 20px;
            }
        }
    }

`;

export const TargetWrapper = styled(FlexBox)`
    .text {
        font-size: 17px;
        line-height: 22px;
        font-weight: 400;   
    }
    
    svg {
        margin-top: 2px;
    }
`;

export const EditTitleContainer = styled(FlexBox)`
    svg {
        cursor: pointer;
        path {
            transition: fill 0.2s;
        }
        &:hover {
            path {
                fill: #151514;
                transition: fill 0.2s;
            }
        }
    }
`;

export const EditTextarea = styled.textarea<{ isEdit?: boolean }>`
    font-size: 30px;
    line-height: 33px;
    font-weight: 600;
    color: #151514;
    font-family: 'Inter';
    outline: none;
    border-color: ${({ isEdit }) => !isEdit ? 'transparent' : '1px solid rgba(144, 144, 144, 1)'};
    padding-bottom: ${({ isEdit }) => !isEdit ? '0' : '4px'};
    border-top: 0;
    border-left: 0;
    border-right: 0;
    border-bottom: ${({ isEdit }) => !isEdit ? 'none' : '0 0 1px 0 solid rgba(144, 144, 144, 1)'};
    overflow-y: hidden;
    resize: none;
    background-color: transparent;
    width: 90%;

    @media(max-width: ${LayoutConst.screen.md}px) {
        font-size: 23px;
        line-height: 27px;
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
        font-size: 20px;
        line-height: 25px;
    }
`;

export const EditTitle = styled.div<{ isEdit?: boolean }>`
    font-size: 30px;
    line-height: 33px;
    font-weight: 600;
    color: #151514;
    font-family: 'Inter';
    padding-bottom: ${({ isEdit }) => !isEdit ? '0' : '4px'};
    border-bottom: ${({ isEdit }) => !isEdit ? 'none' : '1px solid rgba(144, 144, 144, 1)'};
`;

export const SmallLabel = styled.span`
    color: rgba(144, 144, 144, 1);
    font-size: 13px;
    line-height: 16px;
    white-space: nowrap;
    font-weight: 400;
    margin-bottom: 12px;
`;

export const DropdownWrapper = styled.div`
    width: 100%;
    > div {
        width: 100%; 
    }
`;

export const EditButtonsWrapper = styled(FlexBox)`
    .add-button {
        height: 46px;
        max-height: 46px;
        text-align: center;
    }
`;

export const NewCategoryInputsContainer = styled(FlexBox)`
    padding: 24px 0 24px 0;
    border-top: 1px solid rgba(205, 205, 205, 1);
    border-bottom: 1px solid rgba(205, 205, 205, 1);
`;

export const NewCategoryButtonsContainer = styled(FlexBox)`
    ${AddButton} {
        width: calc(50% - 12px);
    }
`;

export const CreateNewCatalogContainer = styled(FlexBox)`
    border-top: 1px solid rgba(205, 205, 205, 1);
    padding-top: 24px;
`;

export const TagsTypeLabel = styled.div`
    font-size: 15px;
    line-height: 16px;
    font-family: 'Inter';
    color: #909090;
    white-space: nowrap;

`;

export const RadioContainer = styled(FlexBox)`
    ${CheckBoxWrapper} {
        width: auto;
    }
`;
